import { h } from 'preact';
import { useEffect, useMemo, useState } from "preact/hooks";

import LoadingSpinner from "../LoadingSpinner";
import FacebookIcon from "../icon/FacebookIcon";
import RaydiantIcon from "../icon/RaydiantIcon";
import TelemetryIcon from "../icon/TelemetryIcon";
import RaydiantLightIcon from "../icon/RaydiantLightIcon";
import { LinkOutlined, QrcodeOutlined, ExclamationCircleTwoTone, CodepenOutlined, SettingOutlined } from '@ant-design/icons';
import LPIcon from "../icon/LPIcon";
import OptiSignIcon from '../icon/OptiSignIcon';

import util, {
  copyText,
  getShareLink,
  getOptisignLink,
  getQRCodeDynamicUrl,
  getLPDashboardLinkFromDesign,
  getLPMainAppLink, getTelemetryLink
} from "../../util";
import qrCodeService from '../../service/qrCodeService';
import designService from "../../service/designService";
import shareService from "../../service/shareService";
import Renderer from "../../canvas/renderer";
import store from "../../store";
import constants from "../../constants";
import * as actions from "../../actions";

import SaveModal from "../SaveModal";
import CreateQRDesignModal from '../CreateQRDesignModal';
import ShareToDisplayModal from '../ShareToDisplayModal';
import EditLinkIcon from "../svg/EditLinkIcon";
import TemplateIcon from "../svg/TemplateIcon";
import MOBackIcon from "../svg/MOBackIcon";
import React from "preact/compat";
import DisplayIcon from '../icon/DisplayIcon';
import dashboardService from '../../service/dashboardService';
import Spinner from '../Spinner';
import memberService from '../../service/memberService';
import { DataSettingsModal } from '../DataSettingsModal';

export default function ShareOptions({
  isNewDesign, designId, parentId, memberId, locationId, isPublishing, isSocialDesign, designName, designSize, designPrivacy,
  setIsSaved, setIsSaving, updateElementAttribute, websiteToken, hasPdfPermission, setActiveMember,
  setShowExitWarning, free, onViewChange, isDigitalMenuBoard, pageNumError, shareLink,
  seoRestaurantName, seoMenuAdjective, seoFoodType, seoCity, seoState, seoShareLinkError, seoExampleTitle, seoExampleText, toggleMenu,
  dsaAutoSyncEnabled, posAutoSyncEnabled, linksAutoSyncEnabled, hasPosData
}) {

  const [isSaveModal, setSaveModal] = useState(false);
  const [saveMode, setSaveMode] = useState('');
  const [createQRAfterSharing, setCreateQRAfterSharing] = useState(false);
  const [isCreateQRDesignModal, setCreateQRDesignModal] = useState(false);
  const [isShareToDisplayModal, setShareToDisplayModal] = useState(false);

  const [view, setView] = useState('default');
  const [shareActions, setActions] = useState('');

  const [facebookConnected, setFacebookConnected] = useState(false);
  const [facebookUsername, setFacebookUsername] = useState('');
  const [facebookPages, setFacebookPages] = useState([]);
  const [facebookCaption, setFacebookCaption] = useState('');
  const [facebookSelectedPage, setFacebookSelectedPage] = useState('');
  const [isFacebookPosting, setIsFacebookPosting] = useState(false);
  const [isFacebookPosted, setIsFacebookPosted] = useState(false);
  const [isOptiSignWindowOpened, setIsOptiSignWindowOpened] = useState(false);
  const [isTelemetryWindowOpened, setIsTelemetryWindowOpened] = useState(false);
  const [isRaydiantWindowOpened, setIsRaydiantWindowOpened] = useState(false);
  const [templateLinkToken, setTemplateLinkToken] = useState('');
  const [telemetryCopyLabel, setTelemetryCopyLabel] = useState('Copy');
  const [screensTotal, setScreensTotal] = useState(0);
  const [isDataSettingsModal, setIsDataSettingsModal] = useState(false);

  const [shareLinkUrl, setShareLinkUrl] = useState('');

  const [usersCount, setUsersCount] = useState(0);

  useEffect(() => {
    if (isNewDesign) {
      setFacebookCaption('');
      setIsFacebookPosted(false);
    }
  }, [isNewDesign]);

  useEffect(() => {
    onViewChange?.(!!shareActions)
  }, [shareActions]);

  useEffect(() => {
    setIsOptiSignWindowOpened(window.data.props.optiSignWindowOpened);
  }, []);

  useEffect(() => {
    setIsTelemetryWindowOpened(window.data.props.telemetryWindowOpened);
  }, []);

  useEffect(() => {
    dashboardService.getScreens().then(resp => {
      setScreensTotal(resp.data.length);
    });
  }, []);

  useEffect(() => {
    memberService.getUsersCount(window.data.member.id).then(resp => {
      setUsersCount(resp.data);
    });
  }, []);

  useEffect(() => {
    if (!designId) return;
    const key = `tli-${designId}`;
    const existingLink = localStorage.getItem(key);
    if (existingLink) {
      setTemplateLinkToken(existingLink);
    } else {
      setTemplateLinkToken('');
    }
  }, [designId])

  useEffect(() => {
    if (shareLink) {
      if (shareLink.restaurantName) updateElementAttribute('seoRestaurantName', shareLink.restaurantName);
      if (shareLink.menuAdjective) updateElementAttribute('seoMenuAdjective', shareLink.menuAdjective);
      if (shareLink.foodType) updateElementAttribute('seoFoodType', shareLink.foodType);
      if (shareLink.city) updateElementAttribute('seoCity', shareLink.city);
      if (shareLink.state) updateElementAttribute('seoState', shareLink.state);
      setShareLinkUrl(getShareLink(shareLink.seoPath || shareLink.designId));

      if (shareLink.seoPath) {
        setSeoExample(shareLink.restaurantName, shareLink.menuAdjective, shareLink.foodType, shareLink.city, shareLink.state);
      }
    }
  }, [shareLink]);

  function setSeoExample(restaurantName, menuAdjective, foodType, city, state) {
    updateElementAttribute('seoExampleTitle', `Menu from ${restaurantName}, ${city}, ${state}`)
    updateElementAttribute('seoExampleText', `The ${restaurantName} menu provides a ${menuAdjective} list of the ${foodType} that can be found in ${city}, ${state}.`)
  }

  setTimeout(() => {
    if ($('.dropdown-menu.dropdown-share').css('display') === 'none') {
      setView('default');
      setIsFacebookPosted(false);
      $('a.share-option').each(function () {
        $(this).removeClass('selected');
      });
    }
  }, 50);

  function showDropdownAfterInitialPublish(classname) {
    setTimeout(() => {
      if ($('.publish-changes-drop').length > 0 && !$('.dropdown-share.initial').hasClass('show')) {
        window.data.design.autoClickedPublish = true;
        $('.publish-changes-drop').trigger('click');
        $(classname)[0].click();
      }
    }, 100);
  }

  function publishShareLink(e) {
    e.stopPropagation();

    if (!util.hasDesignName(designName)) {
      setSaveModal(true);
      setSaveMode('sharing');
      return;
    }

    publishNow('link');
  }

  function getDesignDto() {
    let dto = {
      id: designId,
      html: Renderer.getPagesContent(),
    }

    if (window.data.design.addToFolderId) {
      dto.folders = window.data.design.addToFolderId;
    }

    if (window.data.member.ownerName) {
      dto.creatorName = window.data.member.ownerName;
    }

    return dto;
  }

  function publishNow(clickAfter = '') {
    if (isPublishing) return;

    updateElementAttribute('isPublishing', true);
    designService.updateDesign(getDesignDto()).then(() => {
      if (clickAfter === 'link' || clickAfter === 'optisign' || clickAfter === 'telemetry' || clickAfter === 'raydiant' || clickAfter === 'embed') {
        let seo = null;
        const isAnySEOFieldNotEmpty = seoRestaurantName || seoMenuAdjective || seoFoodType || seoCity || seoState;
        const areAllSEOFieldsFilled = seoRestaurantName && seoMenuAdjective && seoFoodType && seoCity && seoState;

        if (isAnySEOFieldNotEmpty) {
          if (!areAllSEOFieldsFilled) {
            updateElementAttribute('seoShareLinkError', "Please fill up all fields.");
            updateElementAttribute('isPublishing', false);
            return;
          } else {
            updateElementAttribute('seoShareLinkError', "");

            seo = JSON.stringify({
              restaurantName: seoRestaurantName || '',
              menuAdjective: seoMenuAdjective || '',
              foodType: seoFoodType || '',
              city: seoCity || '',
              state: seoState || ''
            });
          }
        }

        qrCodeService.createOrUpdateShareLink(designId, constants.SL_TYPE_SHARE_LINK, seo).then((response) => {
          if (response.data.id) {
            setShareLinkUrl(getShareLink(response.data.seoPath || response.data.designId));

            if (response.data.seoPath) {
              setSeoExample(response.data.restaurantName, response.data.menuAdjective, response.data.foodType, response.data.city, response.data.state);
            }

            store.dispatch(actions.setWebsiteToken(true));
            store.dispatch(actions.setInSync(true));
            updateElementAttribute('isPublishing', false);
            showDropdownAfterInitialPublish(`.share-option.${clickAfter}`);
          } else {
            updateElementAttribute('isPublishing', false);
          }
        }).catch(err => {
          updateElementAttribute('isPublishing', false);
          updateElementAttribute('seoShareLinkError', "Already in use. Try modifying name.");
        });;
      } else {
        designService.generateTemplateLinkInvite(designId).then(resp => {
          const key = `tli-${designId}`;
          localStorage.setItem(key, resp.data);
          setTemplateLinkToken(resp.data);
          updateElementAttribute('isPublishing', false);
          showDropdownAfterInitialPublish(`.share-option.${clickAfter}`);
        });
      }
    });
  }

  function unPublishShareLink(e) {
    e.stopPropagation();

    window.ConfirmationModal.show({
      title: 'Are you sure?',
      body: 'This link will be disabled.',
      acceptLabel: 'OK',
      declineLabel: 'Cancel',
      onAccept: () => {
        updateElementAttribute('isPublishing', true);

        qrCodeService.removeShareLink(designId).then((resp) => {
          store.dispatch(actions.setWebsiteToken(''));
          store.dispatch(actions.setInSync(true));
          cleanUpSEOFields();
          if (toggleMenu) toggleMenu();

          updateElementAttribute('isPublishing', false);
        });

        // DatabankFacade.unpublishTimberWebMenu(designId, false, (response) => {
        //   response = JSON.parse(response);
        //   if (response.status === "FAILURE" || response.status === "ERROR") {
        //     updateElementAttribute('isPublishing', false);
        //     return;
        //   }

        //   store.dispatch(actions.setWebsiteToken(''));
        //   store.dispatch(actions.setInSync(true));
        //   updateElementAttribute('isPublishing', false);
        // });
      },
      onDecline: () => {
        window.ConfirmationModal.hide()
      }
    })
  }

  function cleanUpSEOFields() {
    store.dispatch(actions.setShareLink(null));
    updateElementAttribute('seoRestaurantName', '');
    updateElementAttribute('seoMenuAdjective', '');
    updateElementAttribute('seoFoodType', '');
    updateElementAttribute('seoCity', '');
    updateElementAttribute('seoState', '');
    updateElementAttribute('seoShareLinkError', '');
    updateElementAttribute('seoExampleTitle', '');
    updateElementAttribute('seoExampleText', '');
  }

  function createQRCode() {
    updateElementAttribute('isPublishing', true);
    let qrCodeDto = {};
    qrCodeDto = {
      type: 'saved-design',
      url: designId,
      memberId: memberId,
      locationId: locationId
    }

    qrCodeService.createQRCode(qrCodeDto).then((resp) => {
      updateElementAttribute('isPublishing', false);
      window.data.design.qrCodeId = resp.data.id;
      window.data.design.qrCreated = true;
      if (!props.isMobileVersion && $('.link.qr-tab').length) {
        $('.link.qr-tab')[0].click();
      }

      if (isSaveModal) {
        onSaveModalClose();
      }
      openCreateQRDesignModal();
      setCreateQRAfterSharing(false);
    });
  }

  function checkSaveBeforeCreateQR() {
    if (!util.hasDesignName(designName)) {
      setSaveMode('sharing');
      setCreateQRAfterSharing(true);
      util.nextTick(() => {
        setSaveModal(true);
      })
      return;
    }

    setIsSaved(false);
    setIsSaving(true);
    designService.updateDesign(getDesignDto()).then(response => {
      setIsSaved(true);
      setIsSaving(false);
      createQRCode();
    }).catch((err) => {
      console.error(err);
    })
  }

  function checkCreateQRCode(e) {
    e.stopPropagation();

    if (!hasPdfPermission) {
      showUpgradeModal();
    } else {
      checkSaveBeforeCreateQR();
    }
  }

  function newTableTent(e) {
    e.stopPropagation();

    setIsSaved(false);
    setIsSaving(true);
    $('.modal-back').show();

    designService.updateDesign({
      id: designId,
      templateId: parentId,
      html: Renderer.getPagesContent(),
      name: designName,
      size: designSize,
      privacy: designPrivacy,
    }).then(response => {
      setIsSaved(true);
      setIsSaving(false);

      setShowExitWarning(false);
      window.location.href = constants.appPrefix + '/design?size=table-tent';
    }).catch((err) => {
      $('.modal-back').hide();
    })
  }

  function previewQRCode(e) {
    e.stopPropagation();
    window.open(getQRCodeDynamicUrl(window.data.design.qrCodeId), '_blank').focus();
  }

  function downloadQRCode(e) {
    e.stopPropagation();
    let name = 'qrcode.png';
    let qrCodeImage = util.getQRCodeCanvas(getQRCodeDynamicUrl(window.data.design.qrCodeId)).get(0).toDataURL("image/png");

    const dl = document.createElement('a');
    dl.download = name;
    dl.href = qrCodeImage;
    dl.click();
  }

  function getWebsiteCode(sl) {
    return `<embed src="${sl}?embed=true" style="width: 100%; height: 100%; border: none;" title="${designName}" />`;

    // const host = constants.isLocalhost ? "test.mhmfun.com" : window.location.hostname;

    // return '<script type="text/javascript">\n' +
    //   '\tvar timberUrlParam="&lite=true";\n' +
    //   '\tvar websiteToken="' + websiteToken + '";\n' +
    //   '\tvar width="100%";\n' +
    //   '\tvar height="100%";\n' +
    //   '</script>\n' +
    //   '<script type="text/javascript" src="https://' + host + '/js/weblink.js"></script>\n' +
    //   '<div id="webcode_iframe" style="box-shadow: 0 1px 2px rgba(0,0,0,0.1); border-radius: 8px; border: 1px solid #fff;"></div>';
  }

  function connectFacebook(e) {
    e.stopPropagation();

    if (facebookConnected) return;

    shareService.getFbPermissions(function () {
      shareService.getFbPages(function (pages) {
        if (!pages || pages.length === 0) {
          alert('No Facebook pages found')
        } else {
          setFacebookConnected(true);
          setFacebookPages(pages);
          setFacebookSelectedPage(pages[0].id);

          shareService.getFbUserName(function (name) {
            setFacebookUsername(name);
          });
        }
      });
    });
  };

  function postFacebook(e) {
    e.stopPropagation();

    if (!facebookConnected) {
      alert('You need to connect your account in order to share your design.');
      return;
    }
    let url = (util.isLocalhost() ? 'https://test.mhmfun.com/timber-test' :
      constants.RENDERER_DOMAIN) + '/design/thumbnail/' + designId + '?width=724&checkPermission=true&page=';

    setIsFacebookPosting(true);

    designService.updateDesign(getDesignDto()).then(() => {
      shareService.getFbPages(function () {
        const pageId = facebookSelectedPage;
        const page = facebookPages.find(p => p.id === pageId);

        let imageUrls = [];
        for (let i = 1; i <= util.getNumberOfPages(); i++) {
          let imageUrl = url + i;
          imageUrls.push(imageUrl);
        }

        shareService.postMultiPhotosToWall(pageId, page.access_token, facebookCaption, imageUrls, url, function () {
          setIsFacebookPosting(false);
          setIsFacebookPosted(true);
        });
      });
    });
  }

  function onChangeFacebookPage(e) {
    setFacebookSelectedPage(e.target.value);
  }

  function onChangeFacebookCaption(e) {
    e.stopPropagation();
    setFacebookCaption(e.target.value);
  }

  function showUpgradeModal() {
    if (!hasPdfPermission) {
      window.MHM.ProModal.upgrade({ memberId: window.data.member.id, onSuccess: setActiveMember });
    }
  }

  function onSaveModalClose() {
    setSaveModal(false);
  }

  function openCreateQRDesignModal() {
    setCreateQRDesignModal(true);
  }

  function onCreateQRDesignModalClose() {
    setCreateQRDesignModal(false);
  }

  function showActions(e, type) {
    e.stopPropagation();

    if (!hasPdfPermission) {
      showUpgradeModal();
      return;
    }

    if (pageNumError) return;
    setView(type);

    $('a.share-option').each(function () {
      $(this).removeClass('selected');
    })
    $(e.target).closest('.share-option').addClass('selected');
    if ($('.link-btn').length > 0) {
      $('.link-btn').text('');
    }
  }

  function openLP() {
    if (!hasPdfPermission) {
      showUpgradeModal();
      return;
    }

    if (pageNumError) return;

    let lpTab = window.open()
    qrCodeService.getMemberLandingPages(memberId, false).then(resp => {
      let landingPages = (resp.data || []);

      if (landingPages.length > 1) {
        lpTab.location = getLPMainAppLink();
      } else {
        let LPid = 'new';
        if (landingPages.length === 1) {
          LPid = landingPages[0].id;
        }

        let loc = locationId ? locationId : window.data.member.locationId;
        window.data.design.justAddedToLP = true;
        lpTab.location = getLPDashboardLinkFromDesign(loc, LPid, designId);
      }
    });
  }

  function goToRaydiantLink(e, url) {
    e.stopPropagation();
    if (!websiteToken) {
      publishNow('raydiant');
    }
    qrCodeService.createOrUpdateDigitalSignage(designId, 'raydiant').then();
    window.data.props.raydiantWindowOpened = true;
    setIsRaydiantWindowOpened(true);
    window.open(url, '_blank');
  }

  function goToOptiSignsLink(e, url) {
    e.stopPropagation();
    if (!websiteToken) {
      publishNow('optisign');
    }
    qrCodeService.createOrUpdateDigitalSignage(designId, 'optisign').then();
    window.data.props.optiSignWindowOpened = true;
    setIsOptiSignWindowOpened(true);
    window.open(url, '_blank');
  }

  function goToTelemetryLink(e, url) {
    e.stopPropagation();
    if (!websiteToken) {
      publishNow('telemetry');
    }
    qrCodeService.createOrUpdateDigitalSignage(designId, 'telemetry').then();
    window.data.props.telemetryWindowOpened = true;
    setIsTelemetryWindowOpened(true);
    window.open(url, '_blank');
  }

  function openLinkInNewTab(e, url) {
    e.stopPropagation();
    window.open(url, '_blank');
  }

  function optiSignsBack(e) {
    e.stopPropagation();
    window.data.props.optiSignWindowOpened = false;
    setIsOptiSignWindowOpened(false);
  }

  function telemetryBack(e) {
    e.stopPropagation();
    window.data.props.telemetryWindowOpened = false;
    setIsTelemetryWindowOpened(false);
  }

  function raydiantBack(e) {
    e.stopPropagation();
    window.data.props.raydiantWindowOpened = false;
    setIsRaydiantWindowOpened(false);
  }

  function generateTemplateShareLink(e) {
    e.stopPropagation();

    if (!util.hasDesignName(designName)) {
      setSaveModal(true);
      setSaveMode('sharing');
      return;
    }

    publishNow('template-link');
  }

  function getTemplateLink(designId) {
    return `${window.location.origin}${constants.appPrefix}/invite/${templateLinkToken}`;
  }

  function onBackClick(e) {
    setActions('');
    showActions(e, 'default');
  }

  function copyTelemetryLink(e) {
    copyText(getTelemetryLink(designId), e, false);
    setTelemetryCopyLabel('Copied!');
  }

  const viewName = useMemo(() => {
    switch (view) {
      case 'default':
        return '';
      case 'edit-link':
        return 'Edit Link';
      case 'template-link':
        return 'Template Link';
      case 'link':
        return 'View Only Link'
      case 'embed':
        return 'Embed'
      case 'qr':
        return 'QR Code'
      case 'raydiant':
        return <div><RaydiantLightIcon />Raydiant</div>
      case 'optisign':
        return <div><OptiSignIcon />Optisign</div>
      case 'fb':
        return <div><FacebookIcon />Facebook</div>
      case 'telemetry':
        return <div><TelemetryIcon />TelemetryTV</div>
    }
  }, [view]);

  function goToDisplay() {
    window.open(`${constants.MyMenusPath}/dsa/manage`, '_blank');
  }

  function showDataSettings() {
    util.hideDropdown();
    setIsDataSettingsModal(true);
  }

  useEffect(() => {
    let actions = '';
    switch (view) {
      case 'default':
        break;
      case 'template-link': {
        if (templateLinkToken) {
          actions =
            <div className="share-action">
              <div>Anyone with this link can use this design as a template or copy the design. Sign-in is required.</div>
              <div className="link-block">
                <span className="link-input">{getTemplateLink(designId)}</span>
                <a className="btn primary show-copy-confirmation" onClick={(e) => copyText(getTemplateLink(designId), e)}>Copy</a>
              </div>
            </div>;
        } else {
          actions =
            <div className="share-action">
              <div>Anyone with this link can use this design as a template or copy the design. Sign-in is required.</div>
              <a className="btn primary publish-link" onClick={(e) => generateTemplateShareLink(e)}>
                {isPublishing && <LoadingSpinner />}
                {!isPublishing && <span>Get Link</span>}
              </a>
            </div>;
        }
        break;
      }
      case 'edit-link': {
        actions =
          <div className="share-action">
            <div>Allows team users in an account to share access to this template. Sign-in is required.</div>
            <div className="link-block">
              <span className="link-input">{window.location.href}</span>
              <a className="btn primary show-copy-confirmation" onClick={(e) => copyText(window.location.href, e)}>Copy</a>
            </div>
          </div>;
        break;
      }
      case 'link':
        // if (websiteToken) {
        //   actions =
        //     <div className="share-action">
        //       <div>Anyone with this link can view this design. It will show updates that you publish. You cannot make this design private again.</div>
        //       <div className="link-block">
        //         <span className="link-input">{getShareLink(designId)}</span>
        //         <a className="btn primary show-copy-confirmation" onClick={(e) => copyText(getShareLink(designId), e)}>Copy</a>
        //       </div>
        //       <a className="disable-btn" onClick={(e) => unPublishShareLink(e)}>Disable Link</a>
        //       {!hasPdfPermission && !isSocialDesign && !free &&
        //         <div onClick={() => showUpgradeModal()} className="remove-watermark">
        //           Go Pro to remove watermarks <img src={'/imageservice/images/img/13/pay-modal/Pro2.svg'} alt={''} />
        //         </div>}
        //     </div>;
        // } else {

        if (!websiteToken) {
          publishNow('link');
          actions = <Spinner />
        } else {
          actions =
            <div className="share-action">
              <div>Anyone with this link can view this design. It will show updates that you publish. You cannot make this design private again.</div>

              <div className="link-block">
                <span className="link-input">{shareLinkUrl}</span>
                <a className="btn primary show-copy-confirmation" onClick={(e) => copyText(shareLinkUrl, e)}>Copy</a>
              </div>

              <div className="seo-fields">
                <p>Add SEO Text <small>(optional)</small></p>
                <input placeholder="Restaurant Name" value={seoRestaurantName} onInput={ev => util.debounce(updateElementAttribute('seoRestaurantName', ev.target.value), 1500)} />

                <div>
                  <input placeholder="Menu Adjective" value={seoMenuAdjective} onInput={ev => util.debounce(updateElementAttribute('seoMenuAdjective', ev.target.value), 1500)} />
                  <input placeholder="Food Type" value={seoFoodType} onInput={ev => util.debounce(updateElementAttribute('seoFoodType', ev.target.value), 1500)} />
                </div>

                <div>
                  <input placeholder="City" value={seoCity} onInput={ev => util.debounce(updateElementAttribute('seoCity', ev.target.value), 1500)} />
                  <input placeholder="State" value={seoState} onInput={ev => util.debounce(updateElementAttribute('seoState', ev.target.value), 1500)} />
                </div>
              </div>

              {seoExampleTitle &&
                <div className="seo-example">
                  <b>{seoExampleTitle}</b>
                  {seoExampleText}
                </div>}

              {seoShareLinkError && <p class="error">{seoShareLinkError}</p>}

              <a className={`btn primary publish-link ${!seoRestaurantName || !seoMenuAdjective || !seoFoodType || !seoCity || !seoState ? 'disabled' : ''}`} onClick={(e) => publishShareLink(e)}>
                {isPublishing && <LoadingSpinner />}
                {!isPublishing && <span>Regenerate Link</span>}
              </a>

              <br />

              <a className="disable-btn" onClick={(e) => unPublishShareLink(e)}>Disable Link</a>
            </div>;
        }
        break;

      case 'embed':
        if (!websiteToken) {
          publishNow('embed')
          actions = <Spinner />
        } else {
          actions =
            <div className="share-action">
              <div>Copy and paste link into your site. Adjust 'width' and 'height' in the code to fit.</div>

              <div className="link-block embed">
                <span className="link-input embed">{getWebsiteCode(shareLinkUrl)}</span>
                <a className="embed btn primary show-copy-confirmation" onClick={(e) => copyText(getWebsiteCode(shareLinkUrl), e)}>Copy</a>
              </div>

              <div className="seo-fields">
                <p>Add SEO Text <small>(optional)</small></p>
                <input placeholder="Restaurant Name" value={seoRestaurantName} onInput={ev => util.debounce(updateElementAttribute('seoRestaurantName', ev.target.value), 1500)} />

                <div>
                  <input placeholder="Menu Adjective" value={seoMenuAdjective} onInput={ev => util.debounce(updateElementAttribute('seoMenuAdjective', ev.target.value), 1500)} />
                  <input placeholder="Food Type" value={seoFoodType} onInput={ev => util.debounce(updateElementAttribute('seoFoodType', ev.target.value), 1500)} />
                </div>

                <div>
                  <input placeholder="City" value={seoCity} onInput={ev => util.debounce(updateElementAttribute('seoCity', ev.target.value), 1500)} />
                  <input placeholder="State" value={seoState} onInput={ev => util.debounce(updateElementAttribute('seoState', ev.target.value), 1500)} />
                </div>
              </div>

              {seoExampleTitle &&
                <div className="seo-example">
                  <b>{seoExampleTitle}</b>
                  {seoExampleText}
                </div>}

              {seoShareLinkError && <p class="error">{seoShareLinkError}</p>}

              <a className={`btn primary publish-link ${!seoRestaurantName || !seoMenuAdjective || !seoFoodType || !seoCity || !seoState ? 'disabled' : ''}`} onClick={(e) => publishShareLink(e)}>
                {isPublishing && <LoadingSpinner />}
                {!isPublishing && <span>Regenerate Link</span>}
              </a>

              {!hasPdfPermission && !isSocialDesign && !free &&
                <div onClick={() => showUpgradeModal()} className="remove-watermark">
                  Go Pro to remove watermarks <img src={'/imageservice/images/img/13/pay-modal/Pro2.svg'} alt={''} />
                </div>}
            </div>;
        }
        break;

      case 'qr':
        if (window.data.design.qrCodeId) {
          const qrCodeImage = util.getQRCodeImage(getQRCodeDynamicUrl(window.data.design.qrCodeId)).get(0).outerHTML;
          actions =
            <div className="share-action">
              <div className={'qr-created'}>
                <div className="image qr" data-component="image" dangerouslySetInnerHTML={{ __html: qrCodeImage }}></div>
                <div className={'info'}>
                  <div>Your QR code is saved to your library</div>
                  {window.data.design.qrCreated && <div className="qr-tip">Tip: Add your new QR design to a <a onClick={(e) => newTableTent(e)}>Table Tent</a> for easy scanning!</div>}
                </div>
              </div>
              <div className="qr-btns">
                <a className="btn primary" onClick={(e) => previewQRCode(e)}>Preview</a>
                <a className="btn primary2" onClick={(e) => downloadQRCode(e)}>Download</a>
              </div>
            </div>
        } else {
          actions =
            <div className="share-action">
              <div>Share your design as a QR Code!</div>
              <a className="btn primary publish-link" onClick={(e) => checkCreateQRCode(e)}>
                {isPublishing && <LoadingSpinner />}
                {!isPublishing &&
                  <span>
                    Get QR Code
                    {!hasPdfPermission && !isSocialDesign &&
                      <img src={'/imageservice/images/img/13/pay-modal/Pro2.svg'} alt={''} />}
                  </span>}
              </a>
            </div>;
        }
        break;
      case 'raydiant':
        if (isRaydiantWindowOpened) {
          actions = <div className="share-action raydiant-setup">
            <span className="back-btn" onClick={(e) => raydiantBack(e)}>&#60; Back</span>
            <ul>
              <li>
                <span className="step-num">1</span>
                <span>Go to Raydiant and sign in.</span>
              </li>
              <li>
                <span className="step-num">2</span>
                <span>Click on the My Library tab and click on the +Create button.</span>
              </li>
              <li>
                <span className="step-num">3</span>
                <span>Select the MustHaveMenus app and then click the Connect to MustHaveMenus button.</span>
              </li>
              <li>
                <span className="step-num">4</span>
                <span>Allow Raydiant access to your designs.</span>
              </li>
              <li>
                <span className="step-num">5</span>
                <span>Select a Location, select a Design and enter the page number.</span>
              </li>
              <li>
                <span className="step-num">6</span>
                <span>Save.</span>
              </li>
            </ul>
            <a className="btn primary optisign" onClick={(e) => openLinkInNewTab(e, "https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029390-setting-up-your-digital-menu-board-with-raydiant")}>Read full instructions</a>
          </div>
        } else {
          actions =
            <div className="share-action">
              <div>Sign in or book a demo.</div>
              <div className={'buttons'}>
                <a className="btn primary2 raydiant optisign" onClick={(e) => goToRaydiantLink(e, "https://www.raydiant.com/book-a-demo?utm_source=partner&utm_medium=website&utm_campaign=must-have-menus&utm_content=digital-menu")}>Book a Demo</a>
                <a className="btn primary raydiant optisign" onClick={(e) => goToRaydiantLink(e, "https://dash.raydiant.com/")}>Sign In</a>
              </div>
            </div>;
        }
        break;
      case 'optisign':
        if (isOptiSignWindowOpened) {
          actions = <div className="share-action optisign-setup">
            <span className="back-btn" onClick={(e) => optiSignsBack(e)}>&#60; Back</span>
            <h2>Setup</h2>
            <ul>
              <li>
                <span className="step-num">1</span>
                {isPublishing && <div className="link-block"><LoadingSpinner /></div>}
                {!isPublishing &&
                  <div className="link-block">
                    <LinkOutlined />
                    <span className="link-input">{getOptisignLink(designId)}</span>
                    <a className="link-btn" onClick={(e) => copyText(getOptisignLink(designId), e)}>Copy</a>
                  </div>}
              </li>
              <li>
                <span className="step-num">2</span>
                <span>Go to OptiSigns and select MustHaveMenus App</span>
              </li>
              <li>
                <span className="step-num">3</span>
                <span>Paste in the link and choose which page to display. You may need to use the same link multiple times if multiple pages need to be displayed</span>
              </li>
              <li>
                <span className="step-num">4</span>
                <span>Go to Playlist tab and add the display</span>
              </li>
              <li>
                <span className="step-num">5</span>
                <span>Go to the Display screens tab and follow the steps to connect a playlist</span>
              </li>
            </ul>
            <a className="btn primary optisign" onClick={(e) => openLinkInNewTab(e, "https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029394-set-up-digital-menu-boards-with-optisigns")}>Read full instructions</a>
          </div>
        } else {
          actions =
            <div className="share-action">
              <div>Sign in or create a new account.</div>
              <div className={'buttons'}>
                <a className="btn primary2 optisign" onClick={(e) => goToOptiSignsLink(e, "https://www.optisigns.com/?ref=musthavemenus")}>Create account</a>
                <a className="btn primary optisign" onClick={(e) => goToOptiSignsLink(e, "https://app.optisigns.com/signIn")}>Sign In</a>
              </div>
            </div>;
        }
        break;
      case 'fb':
        shareService.initFb()
        actions =
          <div className="share-action socials">
            <div>Publish your design straight to Facebook. You'll need to connect your account first.</div>
            <ul>
              <li className={`fb ${facebookUsername ? 'connected' : ''}`} onClick={(e) => connectFacebook(e)}>
                <div className={`name ${facebookUsername ? 'connected' : ''}`}>
                  {facebookConnected && <div className={'fb-icon-container'}><FacebookIcon /></div>}
                  {facebookUsername && <span>{facebookUsername}</span>}
                  {!facebookUsername && <a className="btn primary"><span>{'Connect Facebook'}</span></a>}
                </div>

                <div>
                  {facebookConnected ?
                    <select className="pull-right" value={facebookSelectedPage} onChange={(e) => onChangeFacebookPage(e)}>
                      {facebookPages.map(page =>
                        <option value={page.id}>{page.name}</option>)}
                    </select>
                    : ''}
                </div>
              </li>
            </ul>

            {facebookConnected ?
              <div className="form-group">
                <textarea id="post-caption" rows="5" cols="" style="width: 100%" placeholder="Write a caption..."
                  onBlur={(e) => onChangeFacebookCaption(e)}
                  onClick={(e) => onChangeFacebookCaption(e)}
                  value={facebookCaption}>
                </textarea>
              </div>
              : ''}

            {facebookConnected &&
              <div>
                <div className={'btn-wrapper'}>
                  <a className="btn primary facebook" onClick={(e) => postFacebook(e)}>
                    {isFacebookPosting && <LoadingSpinner />}
                    {!isFacebookPosting && !isFacebookPosted && <span>Post to Facebook</span>}
                    {!isFacebookPosting && isFacebookPosted && <span>Posted!</span>}
                  </a>
                </div>
                {!hasPdfPermission && !isSocialDesign && !free &&
                  <div onClick={() => showUpgradeModal()} className="remove-watermark">
                    Go Pro to remove watermarks <img src={'/imageservice/images/img/13/pay-modal/Pro2.svg'} alt={''} />
                  </div>}
              </div>}
          </div>;
        break;
      case 'telemetry':
        if (isTelemetryWindowOpened) {
          actions = <div className="share-action telemetry-setup">
            <span className="back-btn" onClick={(e) => telemetryBack(e)}>&#60; Back</span>
            <h2>Setup</h2>
            <ul>
              <li>
                <span className="step-num">1</span>
                {isPublishing && <div className="link-block"><LoadingSpinner /></div>}
                {!isPublishing &&
                  <div className={'telemetry-link-block'}>
                    <div></div>
                    <div className={'link-block-wrapper'}>
                      <div className="link-block">
                        <span className="link-input"><LinkOutlined /> {getTelemetryLink(designId)}</span>
                        <a className="link-btn" onClick={(e) => copyTelemetryLink(e)}>{telemetryCopyLabel}</a>
                      </div>
                    </div>
                  </div>}
              </li>
              <li>
                <span className="step-num">2</span>
                <span>In the page number drop-down select which page of the menu you wish to display. You will need to repeat these steps for each page you wish to display.</span>
              </li>
              <li>
                <span className="step-num">3</span>
                <span>Click the Copy button to place the link in your paste buffer.</span>
              </li>
              <li>
                <span className="step-num">4</span>
                <span>Go to TelemetryTV and edit or create a new playlist. On the App tab, select Website. In the URL field paste the link you copied in step 3.</span>
              </li>
              <li>
                <span className="step-num">5</span>
                <span>Go to the Display screens tab and follow the steps to connect a playlist</span>
              </li>
            </ul>
            <a className="btn primary telemetry" onClick={(e) => openLinkInNewTab(e, "https://intercom.help/musthavemenus-289b0117ae34/en/articles/11029343-setting-up-your-digital-menu-board-with-telemetrytv")}>Read full instructions</a>
          </div>
        } else {
          actions =
            <div className="share-action">
              <div>Sign in or book a demo.</div>
              <div className={'buttons'}>
                <a className="btn primary2 telemetry" onClick={(e) => goToTelemetryLink(e, "https://www.telemetrytv.com/request-a-demo/")}>Book a demo</a>
                <a className="btn primary telemetry" onClick={(e) => goToTelemetryLink(e, "https://app.telemetrytv.com/start/login")}>Sign In</a>
              </div>
            </div>;
        }
        break;
    }

    setActions(actions);
  }, [view, websiteToken, isPublishing, isFacebookPosting, facebookConnected, facebookUsername, isOptiSignWindowOpened, templateLinkToken, isRaydiantWindowOpened, isTelemetryWindowOpened,
    designName, facebookCaption, facebookSelectedPage, window.data.design.qrCreated, window.data.design.qrCodeId, telemetryCopyLabel, seoRestaurantName, seoMenuAdjective, seoFoodType, seoCity, seoState, shareLink])


  const viewOnlyLinkBtn = <a className="share-option link" onClick={(e) => showActions(e, 'link')}>
    <div className="icon-container">
      <LinkOutlined />
    </div>
    View Only
  </a>;

  const editLinkBtn = <a className="share-option link" onClick={(e) => showActions(e, 'edit-link')}>
    <div className="icon-container">
      <EditLinkIcon />
    </div>
    Edit<br />
    <i>My Team</i>
  </a>;

  const templateLinkBtn = <a className="share-option template-link" onClick={(e) => showActions(e, 'template-link')}>
    <div className="icon-container">
      <TemplateIcon />
    </div>
    Template<br />
    Invite<br />
    <i>External</i>
  </a>;

  const qrLinkBtn = <a className="share-option qr" onClick={(e) => showActions(e, 'qr')}>
    <div className="icon-container">
      <QrcodeOutlined />
    </div>
    QR Code
  </a>;

  const linkPageBtn = <a className="share-option" onClick={openLP}>
    <div className="icon-container">
      <LPIcon />
    </div>
    Link Page
  </a>;

  const embedBtn = <a className="share-option embed" onClick={(e) => showActions(e, 'embed')}>
    <div className="icon-container">
      <CodepenOutlined />
    </div>
    Embed
  </a>;

  const displayBtn = <a className={`share-option display ${screensTotal == 0 ? "disabled" : ""}`} onClick={(e) => {
    if (screensTotal == 0) return;
    setShareToDisplayModal(true);
  }}>
    <div className="icon-container">
      <DisplayIcon />
    </div>
    Display
  </a>;

  const optisignsBtn = <a className="share-option optisign" onClick={(e) => showActions(e, 'optisign')}>
    <div className="icon-container optisign">
      <OptiSignIcon />
    </div>
    OptiSigns
  </a>;

  const raydiantBtn = <a className="share-option raydiant" onClick={(e) => showActions(e, 'raydiant')}>
    <div className="icon-container">
      <RaydiantIcon />
    </div>
    Raydiant
  </a>;

  const telemetryBtn = <a className="share-option telemetry" onClick={(e) => showActions(e, 'telemetry')}>
    <div className="icon-container">
      <TelemetryIcon />
    </div>
    TelemetryTV
  </a>;

  const facebookBtn = <a className="share-option" onClick={(e) => showActions(e, 'fb')}>
    <div className="icon-container fb">
      <FacebookIcon />
    </div>
    Facebook<br />Post
  </a>;

  const displayBanner = <div className="display-banner" onClick={() => goToDisplay()}>
    <div className="col-1">
      <img src="https://timber.mhmcdn.com/site/timber/DisplayBannerThumb.webp" />

      <div class="text-p">
        <p><b>Fully integrated digital menu <br />board solution</b></p>
      </div>

      <div className="icon-container">
        <DisplayIcon />
      </div>
    </div>
  </div>;

  const shareLinksList = <ul className={'drp-dnd shr-ops'}>
    <li>{viewOnlyLinkBtn}</li>
    {usersCount > 1 && <li>{editLinkBtn}</li>}
    <li>{templateLinkBtn}</li>
    <li>{qrLinkBtn}</li>
    <li>{linkPageBtn}</li>
    <li>{embedBtn}</li>
  </ul>;

  return (
    <div className={`share-dropdown ${pageNumError ? 'page-num-error' : ''}`} style={{maxHeight: '80vh', overflowY: 'auto'}}>
      {!shareActions && <div>
        <h4 className="share-drop-title">Sharing Options</h4>

        {hasPosData &&
          <div className="pos-sync-controls btn primary secondary1 full" onClick={showDataSettings}>
            <SettingOutlined /> POS Sync Controls
          </div>
        }

        {!isDigitalMenuBoard &&
          <div className={'share-option-group-wrapper'}>
            <div className={'share-option-group share'}>
              {!hasPdfPermission && <h4>Available with Pro <img src="https://timber.mhmcdn.com/site/marketing/icons/ProStar.svg" alt="pro star" /></h4>}
              {hasPdfPermission && <h4>Share</h4>}
              {shareLinksList}
            </div>

            <hr className={'separator'}></hr>

            {displayBanner}

            <div className={'share-option-group digital'}>
              <h4>Digital Signage</h4>
              <ul className={'drp-dnd shr-ops'}>
                <li className="display-item">{displayBtn}</li>
              </ul>
            </div>

            <hr className={'separator'}></hr>

            <div className={'share-option-group social'}>
              <h4>Social Media</h4>
              <ul className={'drp-dnd shr-ops'}>
                <li>{facebookBtn}</li>
              </ul>
            </div>
          </div>
        }

        {isDigitalMenuBoard &&
          <div className={'share-option-group-wrapper'}>
            <div className={'share-option-group share'}>
              {!hasPdfPermission && <h4>Available with Pro <img src="https://timber.mhmcdn.com/site/marketing/icons/ProStar.svg" alt="pro star" /></h4>}
              {hasPdfPermission && <h4>Share</h4>}
              {shareLinksList}
            </div>

            <hr className={'separator'}></hr>

            {displayBanner}

            <div className={'share-option-group digital'}>
              <h4>Digital Signage</h4>
              <ul className={'drp-dnd shr-ops'}>
                <li className="display-item">{displayBtn}</li>
                <li className="raydiant-item">{raydiantBtn}</li>
                <li className="optisign-item">{optisignsBtn}</li>
                <li className="telemetry-item">{telemetryBtn}</li>
              </ul>
            </div>

            <hr className={'separator'}></hr>

            <div className={'share-option-group social'}>
              <h4>Social Media</h4>
              <ul className={'drp-dnd shr-ops'}>
                <li>{facebookBtn}</li>
              </ul>
            </div>
          </div>
        }

        {pageNumError && <div className="warning pages-warning">
          <ExclamationCircleTwoTone twoToneColor={'#fcac14'} /><span>Video designs can only be 3 pages to share. Please delete additional pages.</span>
        </div>}
      </div>}
      {!!shareActions &&
        <div className={'action'}>
          <div className={'header'}>
            <div className={'back-btn'} onClick={onBackClick}><MOBackIcon /></div>
            <span className={'name'}>{viewName}</span>
          </div>
          {shareActions}
        </div>
      }

      <SaveModal
        open={isSaveModal}
        saveMode={saveMode}
        createQRAfterSharing={createQRAfterSharing}
        createQRCode={createQRCode}
        quitAfterSaving={false}
        onModalClose={onSaveModalClose} />

      <CreateQRDesignModal
        open={isCreateQRDesignModal}
        onClose={onCreateQRDesignModalClose} />

      <ShareToDisplayModal
        open={isShareToDisplayModal}
        onClose={() => { setShareToDisplayModal(false) }} />

      <DataSettingsModal
        designId={designId}
        open={isDataSettingsModal}
        onModalClose={() => setIsDataSettingsModal(false)}
        dsaAutoSyncEnabled={dsaAutoSyncEnabled}
        posAutoSyncEnabled={posAutoSyncEnabled}
        linksAutoSyncEnabled={linksAutoSyncEnabled}
      />
    </div>
  )
}
